import { useTranslation } from "react-i18next";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../components/ToolTip";

function DurchmesserUebergangsrohr({ D = 0 }) {
  const { t } = useTranslation("translation");
  const mindest_durchmesser_uebergangsrohr_formula = `\\displaystyle D \\ge D_{a} + 2 \\cdot c_{req}`;

  return (
    <RowBody
      titleValue={<p>{t("aeussre.minDiameterTransitionPipe")}</p>}
      indicesValue={
        <span>
          D<sub>min</sub>
        </span>
      }
      inputValue={<span className="input">{D?.toFixed(0)}</span>}
      unitValue={<Millimetre />}
      formulaValue={
        <ToolTip
          id={"mindest_durchmesser_uebergangsrohr_formula"}
          type={IconType.FORMULA}
          formula={mindest_durchmesser_uebergangsrohr_formula}
        />
      }
    />
  );
}

export default DurchmesserUebergangsrohr;
